import { render } from "./switch-dialog.vue?vue&type=template&id=0d205799&scoped=true"
import script from "./switch-dialog.vue?vue&type=script&lang=js"
export * from "./switch-dialog.vue?vue&type=script&lang=js"

import "./switch-dialog.vue?vue&type=style&index=0&id=0d205799&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0d205799"

export default script